const defaultData = {
  Date: {
    value: '',
  },
  File: {
    value: {
      description: '',
      displayName: '',
      extension: '',
      keywords: '',
      mimeType: '',
      name: '',
      size: '',
      src: '',
      title: '',
    },
  },
  Title: {
    value: '',
  },
};

export default defaultData;
